/**
 * Fase 2 (Contatos) — utilitários de telefone.
 *
 * Importante: a base atual armazena telefones em formato humano
 * ("+55 11 99999-9999"). Estas funções NÃO são usadas para sobrescrever
 * o valor armazenado — o original é preservado em mobile/phone para
 * compatibilidade com UI existente. Use:
 *
 *   normalizePhoneForMatching → para deduplicação, lookup, comparação
 *   formatPhoneDisplay        → para renderizar bonitinho
 *
 * Reaproveitável pelo ADR-022 (Whapi.Cloud provider adapter futuro).
 */

/**
 * Normaliza telefone para matching/dedup.
 * Brasileiro (10-11 dígitos) recebe prefixo 55. Outros: dígitos só.
 */
export function normalizePhoneForMatching(phone) {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return digits;
}

/**
 * Retorna últimos N dígitos para fuzzy matching (default 8).
 * Útil quando DDI/DDD podem variar entre fontes.
 */
export function lastDigits(phone, n = 8) {
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.slice(-n);
}

/**
 * Formata telefone para exibição amigável.
 * Aceita 10-11 dígitos com ou sem 55 prefixo. Retorna o original se
 * não reconhecer o padrão (não destrói valores fora da convenção BR).
 */
export function formatPhoneDisplay(phone) {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  const local = digits.startsWith('55') && digits.length >= 12
    ? digits.slice(2)
    : digits;
  if (local.length === 11) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  }
  if (local.length === 10) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  }
  return phone;
}
